import type { FC, ReactNode } from 'react'
import { PageHeader, PageHeaderContext, PageLayout } from '#features/AppLayout'
import { ErrorDisplayPage } from '#features/ErrorHandling/ErrorDisplay'

interface ErrorBoundaryProps {
  children?: ReactNode
  headerContent?: ReactNode
  appName: string
}

/**
 * A full error boundary that pushes its own page layout
 */
export const FullPageErrorBoundary: FC<ErrorBoundaryProps> = ({ headerContent, children, appName }) => {
  return (
    <PageHeaderContext>
      <PageLayout>
        <PageHeader appName={appName} />
        <ErrorDisplayPage headerContent={headerContent} hideHeader={false} />
        {children}
      </PageLayout>
    </PageHeaderContext>
  )
}
